import { Collapse, CollapseProps } from "antd";
import React from "react";
import classes from "./SuccessSignListDocs.module.css";
import { SignDocApplicationInfo } from "./items/SignDocApplicationMainInfo/SignDocApllicationInfo";
import { SignDocItem } from "./items/SignDocItem/SignDocItem";
import { ISuccessSignDocsProps } from "../../../../interfaces/props/ISuccessSignDocsProps";

export const SuccessSignListDocs = (props: ISuccessSignDocsProps) => {

  return (
    <div className={classes.documentListWrapper}>
      {props.applications &&
        props.applications?.map((documentData) => {
          const items: CollapseProps["items"] = [
            {
              key: documentData.bank_id,
              label: (
                <SignDocApplicationInfo
                  applicationNumber={documentData.application_id}
                  sumBg={documentData.number_bg || ''}
                  tenderNumber={431241}
                />
              ),
              classNames: { header: classes.itemDocHeader, body: classes.itemDocBody },
              children: documentData.documents.map((el) => {
                if (el.sign_file && el.sign_file.length) {
                  return;
                }

                return (
                  <SignDocItem
                    className={classes.signDocItem}
                    title={el.type_doc.name}
                    subtitle={el.name}
                    key={el.id}
                  />
                )
              }),
            },
          ];

          return (
            <Collapse
              expandIconPosition="end"
              size="large"
              bordered={false}
              accordion
              key={documentData.bank_id}
              items={items}
            />
          );
        })}
    </div>
  );
};
